let BASE_URL = process.env.VUE_APP_API_BASE_URL;
// 开发环境
if(process.env.NODE_ENV == 'development'){
  BASE_URL = process.env.VUE_APP_API_BASE_URL
}else{
  BASE_URL = window.location.origin + '/complaint_data_service'
}
import { agentList } from '@/services/agent'
export default {
    namespaced: true,
    state: {
      defaultConfig:{
            baseURL: BASE_URL,
            agentId:null,
            agentName:null,
            annex:null,
        }, //默认的客服
        currentAgentData:{
          baseURL: BASE_URL,
          agentId:null,
          agentName:'',
          agentTop:1,
          annex:null,
          category: ''
        },//当前会话的客服
        agentList:[], //客服列表,
        topList:[],//置顶的客服
    },
    mutations: {
      // 设置默认的客服
      setDefaultAgent(state,agent) {
        state.defaultConfig.agentId = agent.id
        state.defaultConfig.agentName = agent.agentName
        state.defaultConfig.annex = agent.annex
      },
      // 设置智能体列表
      setAgentList(state,list) {
        state.agentList = list
      },
      // 设置当前会话的客服
      setCurrentAgent(state,agent) {
        state.currentAgentData.agentId = agent.agentId
        state.currentAgentData.agentName = agent.agentName
        state.currentAgentData.agentTop = agent.agentTop
        state.currentAgentData.annex = agent.annex
        state.currentAgentData.category = agent.category
      },
      // 置顶的客服
      setTopList(state,list) {
        state.topList = list
      },
      clearCurrentAgent(state){
        state.currentAgentData = {
          baseURL: BASE_URL,
          agentId:null,
          agentName:''
        }
      }
    },
    actions: {
      // 获取智能体列表
      async getAgentList({commit}) {
        let res = await agentList()
        
        if(res.code == 200){
          let top = []
          res.data.forEach(item => {
            if(item.agentTop == 0){
              top.push(item)
            }
          })
          commit('setTopList',top)
          commit('setAgentList',res.data)
        }
      },
    },
  };
  